import { DefaultRootState } from 'react-redux';
import { matchPath } from 'react-router';
import { Middleware } from 'redux';

import assetsActionTypes from 'components/AssetsList/redux/assets.actionTypes';

import { routes } from 'routes/routes.constants';

const signalRFilterMiddleware: Middleware<object, DefaultRootState> =
  (_store) => (next) => (action: { type: string }) => {
    const isDashboardView = matchPath(window.location.pathname, [
      routes.getSpotAssetPage(),
      routes.getDerivativesAssetPage(),
    ]);
    const { type } = action;

    const tabIsActive = !document.hidden;
    const actionIsNotPriceUpdate =
      type !== assetsActionTypes.SIGNALR_INCOME_RECEIVE_LASTPRICE &&
      type !== assetsActionTypes.SIGNALR_INCOME_RECEIVE_BESTBID &&
      type !== assetsActionTypes.SIGNALR_INCOME_RECEIVE_BESTASK;

    return tabIsActive || isDashboardView || actionIsNotPriceUpdate ? next(action) : null;
  };

export default signalRFilterMiddleware;
